export const HTTP_SUCCESS_CODES = [200, 201];
export const API_SUCCESS_STATUS = 'OK';
